import {UnLitElement, WithEopSlots} from "../../../common/elements";
import {property} from "lit/decorators.js";
import {type DialogOpener, DialogOpenerFactory} from "./dialogOpener";
import {resolve} from "../../../container";

export abstract class DialogAnchorEopSlotContent extends WithEopSlots(UnLitElement) {

    @property({attribute: "disable-close-on-outside-click", type: Boolean})
    public disableCloseOnOutsideClick: boolean = false;

    @property({attribute: "active-from-breakpoint", type: String})
    public activeFromBreakpoint: string = "xs";

    @property({attribute: "dialog-content-eop-slot", type: String})
    public dialogContentEopSlot: string;

    private dialogOpenerFactory: DialogOpenerFactory = resolve(DialogOpenerFactory);
    private dialogOpener: DialogOpener;

    public connectedCallback(): void {
        super.connectedCallback();
        const dialogContent = this.resolveSlot(this.dialogContentEopSlot);
        if (!dialogContent) {
            return;
        }
        this.dialogOpener = this.dialogOpenerFactory.createWithAnchor(dialogContent, this, this.activeFromBreakpoint, this.disableCloseOnOutsideClick);
    }

    public openDialog(e: Event): void {
        this.dialogOpener.openDialog(e);
    }
}
